import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { contact } from '../../data/site';
export function ContactCTA() {
  return <section className="bg-cream" data-id="element-35" data-mp="3pm4e3r6qzuxy">
      <div className="mx-auto grid max-w-page gap-10 border-t border-ink/10 px-6 py-20 lg:grid-cols-12 lg:items-start lg:gap-16 lg:px-10 lg:py-24" data-id="element-36" data-mp="3pme95t6ngsai">
        <div className="lg:col-span-7" data-id="element-37" data-mp="3ktbcvdahn4qm">
          <h2 className="max-w-xl font-serif text-3xl font-light leading-tight text-ink sm:text-[2.75rem]" data-id="element-38" data-mp="3e4twpqga4yc">
            Le premier cours sert à faire connaissance
          </h2>
          <p className="mt-5 max-w-lg text-[1.0625rem] leading-relaxed text-ink/70" data-id="element-39" data-mp="cfm9m6zy44mi">
            Dites-moi où vous en êtes — douleurs, reprise après une pause, envie de bouger autrement.
            Je vous propose la méthode et le format qui conviennent, sans engagement.
          </p>
          <Link to="/contact" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm text-ivory transition-colors duration-150 ease-soft hover:bg-sage-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-40" data-mp="2e8sgvz5huakr">
            Me contacter
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="3ig4dxxxkw32h" />
          </Link>
        </div>

        <dl className="space-y-6 text-sm lg:col-span-5 lg:pt-3" data-id="element-42" data-mp="3n9gvjo3ub9lq">
          <div data-id="element-43" data-mp="3s679a4s69t3z">
            <dt className="text-ink/45" data-id="element-44" data-mp="3s6pc5k9cb5kv">Studio</dt>
            <dd className="mt-1 text-ink" data-id="element-45" data-mp="36d7osyp679">{contact.address}</dd>
          </div>
          <div data-id="element-46" data-mp="5ar8zkkrll9">
            <dt className="text-ink/45" data-id="element-47" data-mp="52sovtt56edy">Horaires</dt>
            <dd className="mt-1 space-y-1 text-ink" data-id="element-48" data-mp="532fnjm0gpkp">
              {contact.hours.map(line => <p key={line} data-id="element-49" data-mp="a1412b6wt0zc">{line}</p>)}
            </dd>
          </div>
          <div data-id="element-50" data-mp="26v7dfbq6yh3c">
            <dt className="text-ink/45" data-id="element-51" data-mp="26vqktyi7tn34">Direct</dt>
            <dd className="mt-1 space-y-1" data-id="element-52" data-mp="2bsh22p5raoq4">
              <p data-id="element-53" data-mp="2bt8zm5iwywj1">
                <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="text-ink hover:text-sage-deep" data-id="element-54" data-mp="2butszrths9fb">
                  {contact.phone}
                </a>
              </p>
              <p data-id="element-55" data-mp="1zsipbe24w509">
                <a href={`mailto:${contact.email}`} className="text-ink hover:text-sage-deep" data-id="element-56" data-mp="1zt29z2j657hz">
                  {contact.email}
                </a>
              </p>
            </dd>
          </div>
        </dl>
      </div>
    </section>;
}